module.exports = __webpack_public_path__ + "media/testimonials/1-a6b56a46.jpg";